import React from 'react';

import { useParams } from 'react-router-dom';

import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import { useQuery } from '@tanstack/react-query';
import LoadingSpinner from 'src/components/shared/loadingSpinner/loadingSpinner';
import { getAssociateProfileQueryOptions } from 'src/services/associateProfile/associateProfileQueries';
import type { AssociateProfileRestriction } from 'src/services/associateProfile/types';
import { useAppSelector } from 'src/store/store';

import RestrictionCardLayout from './restrictionCardLayout';

const AssociateProfileRestrictions = () => {
  const { alias } = useParams();
  const { selectedSite } = useAppSelector((state) => state.sites);

  const restrictionsQuery = useQuery(getAssociateProfileQueryOptions.restrictions(alias ?? '', selectedSite.id));

  const restrictionSort = (a: AssociateProfileRestriction, b: AssociateProfileRestriction) => {
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  };

  if (restrictionsQuery.isPending) {
    return <LoadingSpinner />;
  }

  if (restrictionsQuery.isError) {
    return <Text>Oops! Something went wrong.</Text>;
  }

  const restrictions = restrictionsQuery.data;

  if (
    restrictions.pending.length === 0 &&
    restrictions.active.length === 0 &&
    restrictions.transferredIn.length === 0
  ) {
    return <Text>There were no restrictions found for this Associate</Text>;
  }

  return (
    <Column spacing="400">
      <Column>
        <Text type="b500">
          Pending Restrictions ({restrictions.pending.length + restrictions.transferredIn.length})
        </Text>
        {[...restrictions.pending, ...restrictions.transferredIn].sort(restrictionSort).map((r) => (
          <RestrictionCardLayout key={`${r.accommodationId}-${r.taskName}`} restriction={r} />
        ))}
      </Column>
      <Column>
        <Text type="b500">Active Restrictions ({restrictions.active.length})</Text>
        {[...restrictions.active].sort(restrictionSort).map((r) => (
          <RestrictionCardLayout key={`${r.accommodationId}-${r.taskName}`} restriction={r} />
        ))}
      </Column>
    </Column>
  );
};

export default AssociateProfileRestrictions;
